export default "__VITE_ASSET__Spf0vlGX__"